import GradientBorderRadius from "@/ui/gradient-border-radius.tsx";
import { useState } from "react";

type UploadInputProps = {
  setFile: (f: File) => void;
};

const UploadInput = ({ setFile }: UploadInputProps) => {
  const [localFile, setLocalFile] = useState<File | undefined>(undefined);
  return (
    <GradientBorderRadius
      hover="r-100"
      className="focus-within:before:bg-gradient-100 w-full h-full"
    >
      <label className="w-full h-full flex items-center justify-center cursor-pointer text-gray">
        <input
          type="file"
          className="hidden"
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) {
              setLocalFile(file);
              setFile(file);
            }
          }}
        />
        {localFile?.name || "Choose file"}
      </label>
    </GradientBorderRadius>
  );
};
export default UploadInput;
